export default __webpack_public_path__ + "static/media/FreshAutoPesu.a6e04d2a.png";